module.exports = __webpack_public_path__ + "img/artboard_bk_5.6e2ec58d.png";